import { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function PreprocessingTab({ id }) {
  const [pp, setPp] = useState(null);
  useEffect(() => {
    endpoints.preprocessing(id).then((r) => setPp(r.data.preprocessing));
    const t = setInterval(() => endpoints.preprocessing(id).then((r) => setPp(r.data.preprocessing)), 4000);
    return () => clearInterval(t);
  }, [id]);

  if (!pp) return <div className="text-sm text-muted-foreground">Preprocessing plan not ready yet…</div>;

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-3 gap-3">
        <Card label="NUMERIC" value={pp.numeric?.length || 0} />
        <Card label="CATEGORICAL" value={pp.categorical?.length || 0} />
        <Card label="DROPPED" value={pp.dropped_columns?.length || 0} accent={pp.dropped_columns?.length > 0} />
      </div>

      <div>
        <div className="label-mono mb-4">// STEPS APPLIED</div>
        <div className="space-y-3">
          {pp.steps.map((s, i) => (
            <div key={i} className="border border-border rounded-sm p-5 bg-card" data-testid={`prep-step-${i}`}>
              <div className="flex items-center gap-3 mb-2">
                <span className="label-mono text-accent">STEP {String(i + 1).padStart(2, "0")}</span>
                <span className="font-display font-semibold">{s.step}</span>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed mb-3">{s.reason}</p>
              {s.columns?.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                  {s.columns.slice(0, 20).map((c) => (
                    <Badge key={c} variant="outline" className="font-mono text-[10px]">{c}</Badge>
                  ))}
                  {s.columns.length > 20 && <span className="text-xs text-muted-foreground">+{s.columns.length - 20} more</span>}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Card({ label, value, accent }) {
  return (
    <div className={`border rounded-sm p-4 bg-card ${accent ? "border-accent/40" : "border-border"}`}>
      <div className="label-mono">{label}</div>
      <div className={`num font-display font-bold text-2xl mt-1 ${accent ? "text-accent" : ""}`}>{value}</div>
    </div>
  );
}
